/**
 * Application constants and defaults.
 * Centralized here for easy modification.
 * @module config
 */

/** Default email pre-filled in the input (empty = no default). */
export const DEFAULT_EMAIL = "";

/** Default SBI banner text for the footer. */
export const DEFAULT_BANNER =
  "54 RUE DE PARADIS - PARIS | WWW.SBI-GROUP.COM | 01 85 08 86 00";

/** localStorage key for saved user options (checkboxes, select). */
export const OPTIONS_STORAGE_KEY = "word_addin_options";

/** localStorage key for saved user email. */
export const EMAIL_STORAGE_KEY = "word_addin_email";
